import dayjs from 'dayjs';

export const dateFormatCase = {
  international: 'DD-MM-YYYY HH:mm:ss',
  usa: 'MM-DD-YYYY hh:mm a',
  internationalHours: 'HH:mm:ss',
  usaHours: 'hh:mm a',
  internationalDate: 'DD.MM.YYYY',
  usaDate: 'MM.DD.YYYY',
  internationalChat: 'DD MMMM',
  usaChat: 'DD MMMM', // 'MM/DD/YYYY',
  internationalChatList: 'DD.MM.YYYY',
  usaChatList: 'MM.DD.YYYY',
  internationalTime: 'HH:mm',
  usaTime: 'hh:mm a',
  dayOfWeek: 'dd'
};

const getDateWithTimeZone = (date: string | number, type: keyof typeof dateFormatCase, checkIsToday?: boolean) => {  
  const timeOffset = dayjs().utcOffset();
  const unixTimeWithTimeZone = dayjs(date).valueOf() + timeOffset * 60 * 1000;

  if (checkIsToday && dayjs(unixTimeWithTimeZone).isToday() && ['international', 'usa'].includes(type)) {
    return dayjs(unixTimeWithTimeZone).format(dateFormatCase[`${type}Hours` as keyof typeof dateFormatCase]);
  }
  
  if (checkIsToday && type.includes('ChatList')) {
    const dataFormat = type.replace('ChatList', 'Time');
    if (dayjs(unixTimeWithTimeZone).isToday()) return dayjs(unixTimeWithTimeZone).format(dateFormatCase[dataFormat as keyof typeof dateFormatCase]);

    const diffInDays = dayjs().diff(dayjs(date).utc(), 'day');
    if (diffInDays < 7) return dayjs(unixTimeWithTimeZone).format(dateFormatCase['dayOfWeek' as keyof typeof dateFormatCase]);
  }


  if (type?.includes('Chat')) {
    const diffInWeeks = dayjs().diff(dayjs(date).utc(), 'week');    
    
    if (diffInWeeks > 48) {
      const format = dateFormatCase[type as keyof typeof dateFormatCase] + ' YYYY';      
      return dayjs(unixTimeWithTimeZone).format(format);
    }
  }

  return dayjs(unixTimeWithTimeZone).format(dateFormatCase[type]);
};

export default getDateWithTimeZone;
